import script from "./WegowErrorMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./WegowErrorMessage.vue?vue&type=script&setup=true&lang=js"

import "./WegowErrorMessage.vue?vue&type=style&index=0&id=13d5c15f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13d5c15f"]])

export default __exports__